"use strict";
var Cache = (function () {
    function Cache() {
        this._cache = {};
    }
    Cache.prototype.add = function (key, opts) {
        this._cache[key] = opts;
    };
    Cache.prototype.get = function (key) {
        return this._cache[key];
    };
    Cache.prototype.clear = function () {
        this._cache = {};
    };
    return Cache;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Cache;
